import { useEffect } from 'react'
import { FaFilter } from 'react-icons/fa'
import { VscClearAll } from 'react-icons/vsc'
import Select from 'react-select'
import Button from '../../shared/components/Button/Button'
import selectStyles from '../../shared/css/SelectStyle'

function ColorFilterModal({ filters, onChange, onClear, onClose, providerOptions, clothOptions, colorTypeOptions }) {

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [onClose])

    return (
        <div className="fm-overlay" onClick={onClose}>
            <div className="fm-box" onClick={(e) => e.stopPropagation()}>

                {/* ── Header ── */}
                <div className="fm-header">
                    <div className="fm-header-top">
                        <div className="fm-header-left">
                            <FaFilter size={24} className="fm-header-icon" />
                            <div>
                                <p className="fm-title">Filtrar cores</p>
                                <span className="fm-accent" />
                            </div>
                        </div>
                        <button className="fm-close shd-modal-close" onClick={onClose}>X</button>
                    </div>
                    <div className="fm-header-actions">
                        <Button variant="cancel" icon={VscClearAll} onClick={onClear}>Limpar</Button>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className="fm-body">

                    <div className="fm-section">
                        <span className="fm-label">Fornecedor</span>
                        <Select
                            isClearable
                            options={providerOptions || []}
                            styles={selectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            value={(providerOptions || []).find((o) => o.value === filters.provider) || null}
                            onChange={(option) => onChange('provider', option ? option.value : '')}
                            placeholder="Todos"
                        />
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Tecido</span>
                        <Select
                            isClearable
                            options={clothOptions || []}
                            styles={selectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            value={(clothOptions || []).find((o) => o.value === filters.cloth) || null}
                            onChange={(option) => onChange('cloth', option ? option.value : '')}
                            placeholder="Todos"
                        />
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Tipo de Cor</span>
                        <Select
                            isClearable
                            options={colorTypeOptions || []}
                            styles={selectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            value={(colorTypeOptions || []).find((o) => o.value === filters.colorType) || null}
                            onChange={(option) => onChange('colorType', option ? option.value : '')}
                            placeholder="Todos"
                        />
                    </div>

                </div>

            </div>
        </div>
    )
}

export default ColorFilterModal
